(function(){
  if(window.__btCardInit) return;
  window.__btCardInit = true;
  document.addEventListener('click', function(e){
    var chip = e.target.closest('.bt-size-chip:not([disabled])');
    if(!chip) return;
    var form = chip.closest('.bt-card__quick-add-form');
    if(!form) return;
    form.querySelectorAll('.bt-size-chip').forEach(function(c){ c.classList.remove('is-selected'); });
    chip.classList.add('is-selected');
    form.querySelector('.bt-card__selected-variant').value = chip.dataset.variantId;
    var hint = form.querySelector('.bt-card__quick-add-hint');
    if(hint) hint.textContent = 'Adding ' + chip.dataset.variantTitle + '\u2026';
    var fd = new FormData(form);
    fd.set('id', chip.dataset.variantId);
    fetch(form.action, { method:'POST', headers:{'X-Requested-With':'XMLHttpRequest','Accept':'application/json'}, body:fd })
      .then(function(r){ return r.json(); })
      .then(function(data){
        if(data.status === 422){
          if(hint) hint.textContent = 'Sold out in ' + chip.dataset.variantTitle;
          chip.classList.remove('is-selected');
        } else {
          if(hint) hint.textContent = chip.dataset.variantTitle + ' added!';
          document.dispatchEvent(new CustomEvent('cart:updated', {detail:data}));
          setTimeout(function(){ chip.classList.remove('is-selected'); if(hint) hint.textContent='Pick a size to add'; }, 1800);
        }
      })
      .catch(function(){ if(hint) hint.textContent='Something went wrong.'; });
  });
})();
